import {IHttpResponse} from './Service';
import {AuthenticatedService} from './AuthenticatedService';
import {Page} from '../Models';

export interface DevelopmentTicket {
  ticketNumber: string;
  summary: string;
  resolutionDate: Date;
  releaseNote: string;
  version: string;
  modules: string[];
}

export class TicketService extends AuthenticatedService {
  public listAllDevelopment = async (page: number): Promise<IHttpResponse<Page<DevelopmentTicket>>> => {
    const tickets = await this.getAuth<Page<DevelopmentTicket>>(
      `tickets/development/released?page=${page}`,
    );

    return tickets;
  }

  public listUnreleasedDevelopment = async (page: number): Promise<IHttpResponse<Page<DevelopmentTicket>>> => {
    const tickets = await this.getAuth<Page<DevelopmentTicket>>(
      `tickets/development/unreleased?page=${page}`,
    );

    return tickets;
  }

  public listDevelopmentByVersion = async (page: number, version: string): Promise<IHttpResponse<Page<DevelopmentTicket>>> => {
    const tickets = await this.getAuth<Page<DevelopmentTicket>>(
      `tickets/development/version/${version}?page=${page}`,
    );

    return tickets;
  }

  public listVersions = async (): Promise<IHttpResponse<string[]>> => {
    const versions = await this.getAuth<string[]>(
      'tickets/versions',
    );

    return versions;
  }
}
